import React, { FunctionComponent } from 'react';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { SanityImage, SanitySlug, SanityTeaser } from '../../../types/common';
import { urlFor } from '../../../utils/imageBuilder';
import { InternalLinkIcon } from '../../Icons';
import InternalLink from '../../InternalLink';
import './styles.scss';

type AboutUsHomeProps = {
  data: {
    title?: string | undefined;
    description?: string | undefined;
    cta?: string | undefined;
    pageReference: {
      title: string;
      slug: SanitySlug;
      teaser?: SanityTeaser | null;
    }
    image: SanityImage;
    background: SanityImage;
    imageAlign: 'top' | 'bottom';
  };
}

const AboutUsHome: FunctionComponent<AboutUsHomeProps> = ({ data }) => {
  const { isMobile } = useScreenSize();

  if (isMobile) {
    return (
      <InternalLink reference={data.pageReference}>
        <div className='about-us-home'>
          {data.background?.asset?.url && (

            <picture className='mobile-image'>
              <source media="(min-width:650px)" srcSet={urlFor(data.background).width(1000).quality(100).url()} />
              <img
                src={urlFor(data.background).width(650).quality(100).url()}
                alt={data.background?.alt}
                loading='lazy'
              />
            </picture>
            // <img
            //   className='mobile-image'
            //   src={urlFor(data.background).width(375).quality(90).url()}
            //   alt={data.background?.alt}
            //   loading='lazy'
            // />
          )}
          <div className='mobile-content'>
            <div>
              <h3>{data.title ? data.title : data.pageReference.teaser?.title ? data.pageReference.teaser?.title : data.pageReference.title}</h3>
              {(data.description || data.pageReference.teaser?.description) && (
                <p>{data.description ? data.description : data.pageReference.teaser?.description}</p>
              )}
            </div>
            <InternalLinkIcon />
          </div>
        </div>
      </InternalLink>
    );
  }

  return (
    <section className='about-us-home'>
      <div>
        <div>
          <div>
            <h3>{data.title ? data.title : data.pageReference.teaser?.title ? data.pageReference.teaser?.title : data.pageReference.title}</h3>
            {(data.description || data.pageReference.teaser?.description) && (
              <p>{data.description ? data.description : data.pageReference.teaser?.description}</p>
            )}
          </div>
          <InternalLink
            reference={data.pageReference}
            className='primary-button'
          >
            {data.cta ? data.cta : data.pageReference.teaser?.cta ? data.pageReference.teaser.cta : 'Learn more'}
            <InternalLinkIcon />
          </InternalLink>
        </div>

        <img
          src={urlFor(data.image).width(350).quality(90).url()}
          alt={data.image.alt}
          className={data.imageAlign}
          loading='lazy'
        />
      </div>
    </section>
  );
}

export default AboutUsHome;
